import Group from "react-select/src/components/Group";
import i18next from "i18next";

export const BAR_CHART_TYPES = {
  ssr: "ssr",
  after_sales: "after_sales",
  new_vehicle: "new_vehicle",
  used_vehicle: "used_vehicle",
  quartiles: "quartiles",
  quality: "quality",
};

export const SEVERAL_CHARTS_LABELS = {
  value: "ValueIndicatorId",
  average: "AverageIndicatorId",
  difference: "DifferenceIndicatorId",
  group_average: "GroupAverageIndicatorId",
};

export const getStaticNumberBars = (values, type) => {
  if (type === BAR_CHART_TYPES.quartiles) {
    return values;
  } else {
    let resultArray = [];
    switch (type) {
      case BAR_CHART_TYPES.ssr:
        resultArray = [1, 2];
        break;
      case BAR_CHART_TYPES.after_sales:
        resultArray = [1, 2, 3];
        break;
      case BAR_CHART_TYPES.new_vehicle:
        resultArray = [1, 2, 3, 4, 5, 6];
        break;
      case BAR_CHART_TYPES.used_vehicle:
        resultArray = [1, 2, 3, 4, 5, 6];
        break;
    }
    return resultArray.map((item, i, arr) => {
      const firstIndex = arr.length - values.length;
      return i >= firstIndex ? values[i - firstIndex] : "";
    });
  }
};

export const getChartData = (data = [], type = "", severalChartsValues) => {
  const barColors =
    type === BAR_CHART_TYPES.new_vehicle ||
    type === BAR_CHART_TYPES.used_vehicle
      ? data.map((d, i, arr) =>
          i === arr.length - 1
            ? "rgba(241, 121, 44, .9)"
            : "rgba(180, 180, 180, .9)"
        )
      : [
          "rgba(73, 90, 100, .9)",
          "rgba(241, 121, 44, .9)",
          "rgba(180, 180, 180, .9)",
        ];

  const datasets =
    type === BAR_CHART_TYPES.quartiles
      ? Object.keys(severalChartsValues).map((legend) => ({
          label: i18next.t(`q.${legend}`),
          data: severalChartsValues[legend],
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderSkipped: false,
          borderColor:
            legend === SEVERAL_CHARTS_LABELS.value
              ? "rgba(255, 102, 0, 1)"
              : legend === SEVERAL_CHARTS_LABELS.difference
              ? "rgba(59, 190, 200, 1)"
              : legend === SEVERAL_CHARTS_LABELS.average
              ? "rgba(255, 163, 94, 1)"
              : legend === SEVERAL_CHARTS_LABELS.group_average
              ? "rgba(50, 140, 149, 1)"
              : "rgba(50, 50, 50, 1)",
          borderWidth:
            legend === SEVERAL_CHARTS_LABELS.value ||
            legend === SEVERAL_CHARTS_LABELS.difference
              ? 3
              : 1,
          type:
            (legend === SEVERAL_CHARTS_LABELS.average ||
              legend === SEVERAL_CHARTS_LABELS.group_average) &&
            "line",
        }))
      : [
          {
            data,
            backgroundColor: barColors,
            borderColor: "rgba(255, 102, 0, 1)",
            borderWidth: 1,
          },
        ];

  return {
    datasets,
  };
};

export const getChartOptions = (
  numberBars = 2,
  labels = [],
  data,
  text = "",
  type = ""
) => {
  const isQ = type === BAR_CHART_TYPES.quartiles;
  const FullArrayData = isQ
    ? Object.keys(data).reduce((acc, key) => {
        acc = [...data[key], ...acc];
        return acc;
      }, [])
    : data;

  const minVal = Math.min(...FullArrayData);
  const maxVal = Math.max(...FullArrayData);

  const stepSize =
    (maxVal <= 10 && 1) ||
    (10 < maxVal && maxVal < 200 && 10) ||
    (200 < maxVal && maxVal <= 10000 && 500) ||
    1000;
  const min = isQ
    ? minVal - stepSize > 0
      ? 0
      : Math.floor(minVal / stepSize) * stepSize - stepSize
    : numberBars !== 3
    ? Math.floor(minVal / stepSize) * stepSize
    : 0;

  const max =
    Math.ceil(maxVal / stepSize) * stepSize +
    stepSize * (numberBars > 3 ? 1 : 2);

  if (type === BAR_CHART_TYPES.quality) {
    return {
      scale: {
        gridLines: {
          display: true,
          color: "#d9d9d9",
        },
        ticks: {
          display: false,
          beginAtZero: true,
          min: -40,
          max: 100,
          stepSize: 20,
        },
        pointLabels: {
          fontSize: 11,
          maxWidth: "20px",
          display: "inline-block",
          whiteSpace: "pre-wrap",
          fontStyle: "normal",
          fontColor: "#495964",
          fontFamily: "LADA_Pragmatica",
        },
      },
      legend: {
        display: false,
      },
    };
  } else {
    return {
      aspectRatio:
        (type === BAR_CHART_TYPES.ssr && 13.2 / 20) ||
        (type === BAR_CHART_TYPES.after_sales && 19 / 20) ||
        (type === BAR_CHART_TYPES.new_vehicle && 1) ||
        (type === BAR_CHART_TYPES.used_vehicle && 1) ||
        (type === BAR_CHART_TYPES.quartiles && 3 / 1),
      hover: {
        animationDuration: 0,
      },
      legend: {
        display: isQ,
        position: "bottom",
        align: "start",
        fullWidth: false,
        labels: {
          boxWidth: 15,
          fontSize: 13,
          padding: 20,
          fontFamily: "LADA_Pragmatica",
        },
      },
      title: {
        display: true,
        text,
        fontSize: 11,
        fontStyle: "normal",
        fontColor: "#495964",
        fontFamily: "LADA_Pragmatica",
      },
      scales: {
        yAxes: [
          {
            ticks: {
              display: isQ,
              min:
                type === BAR_CHART_TYPES.new_vehicle ||
                type === BAR_CHART_TYPES.used_vehicle
                  ? minVal - 400 > 0
                    ? minVal - 400
                    : 0
                  : min,
              max: type === BAR_CHART_TYPES.new_vehicle ? maxVal + 400 : max,
              maxTicksLimit: isQ ? 10 : 4,
              stepSize,
            },
            gridLines: {
              color: isQ
                ? "#d9d9d9"
                : ["#d9d9d9", "#d9d9d9", "#d9d9d9", "#2C292E"],
            },
          },
        ],
        xAxes: [
          {
            labels,
            ticks: {
              fontSize: 9,
              fontStyle: "normal",
              fontColor: "#495964",
              fontFamily: "LADA_Pragmatica",
            },
            // barPercentage: 1,
            gridLines: {
              offsetGridLines: false,
              color: "#d9d9d9",
            },
            offset: true,
          },
        ],
      },
    };
  }
};
